import { findLast, getRelativeTime, isNumber, relativeNow } from '@datadog/browser-core';
import { RumPerformanceEntryType, supportPerformanceTimingEvent } from './performanceObservable';
export function getNavigationEntry() {
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
        const navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
        if (navigationEntry) {
            return navigationEntry;
        }
    }
    const timings = computeTimingsFromDeprecatedPerformanceTiming();
    const entry = {
        entryType: RumPerformanceEntryType.NAVIGATION,
        initiatorType: 'navigation',
        name: window.location.href,
        startTime: 0,
        duration: timings.loadEventEnd,
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        workerStart: 0,
        toJSON: () => ({ ...entry, toJSON: undefined }),
        ...timings,
    };
    return entry;
}
export function computeTimingsFromDeprecatedPerformanceTiming() {
    const result = {};
    const timing = performance.timing;
    for (const key in timing) {
        if (isNumber(timing[key])) {
            const numberKey = key;
            const timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : getRelativeTime(timingElement);
        }
    }
    return result;
}
export function sanitizeFirstByte(entry) {
    // In some cases the value reported is negative or is larger
    // than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    return entry.responseStart >= 0 && entry.responseStart <= relativeNow() ? entry.responseStart : undefined;
}
export function getResourceEntries() {
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.RESOURCE)) {
        return performance.getEntriesByType(RumPerformanceEntryType.RESOURCE);
    }
    return undefined;
}
/**
 * Find the most relevant resource entry for an LCP element.
 *
 * Resource entries persist for the entire page lifetime and can include multiple requests
 * for the same URL (preloads, cache-busting reloads, SPA route changes, etc.).
 * This function returns the most recent matching entry that started before the LCP time,
 * which is most likely the one that triggered the LCP paint.
 */
export function findLcpResourceEntry(resourceUrl, lcpStartTime) {
    const entries = getResourceEntries();
    if (!entries) {
        return undefined;
    }
    return findLast(entries, (entry) => entry.name === resourceUrl && entry.startTime <= lcpStartTime);
}
//# sourceMappingURL=performanceUtils.js.map